import React, { useState } from "react";
import { Page } from "./styles";
import { BiShowAlt} from "react-icons/bi";
import moment from "moment";
import 'moment/locale/pt-br'
import { ModalInfo } from "../ModalInfo";
moment.locale('pt-br');
// moment.updateLocale('pt',{
//   calendar:{
//     sameDay:'[Hoje às] HH:mm',
//     lastDay:'',
//     lastWeek:'',
//     nextDay:'',
//     nextWeek:'',
//     sameElse:''

//   }
// })
export interface ILog {
  id: string;
  message: string;
  createdAt: Date;
}
const Log = ({ id, message, createdAt}: ILog) => {
  const [viewDetails, setViewDetails] = useState(false);
  function handleCloseViewDetails() {
    setViewDetails(false)
  }
  function handleOpenViewDetails() {
    setViewDetails(true)
  }
  return (
    <Page>
      {
        viewDetails && <ModalInfo 
        confirm={handleCloseViewDetails}
        title={message}
        />
      }
      
      <div className="more" onClick={handleOpenViewDetails}>
        <BiShowAlt />
      </div>
      <div className="text">
        <span>{moment(createdAt).startOf('minute').fromNow()} - </span>
        <div>
          {message}
        </div>
      </div>
    </Page>
  );
};
export { Log };
